import axios from "axios";
import { banner, webView } from "../../variables/webView";
import {
  validShortGoogleMap,
  validShortGoogleMap2,
} from "../../RegExpValidations";
import GetQrLink from "./getQrLink";
export { GetQrLink };

export const MapApi = async (data) => {
  let response = null;
  const coords =
    validShortGoogleMap.test(data.link) || validShortGoogleMap2.test(data.link)
      ? { link: data.link }
      : { latitude: data.latitude, longitude: data.longitude };

  try {
    response = await axios.post(
      webView ? `/entry/map/ajax/new${banner}` : `/entry/map/ajax/new`,
      {
        qrTitle: data.qrTitle,
        advertisingIabCategories: data.category || [],
        ...coords,
      }
    );
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const MapApiEdit = async (data) => {
  let response = null;
  const coords =
    validShortGoogleMap.test(data.link) || validShortGoogleMap2.test(data.link)
      ? { link: data.link }
      : { latitude: data.latitude, longitude: data.longitude };
  try {
    response = await axios.post(`/entry/map/ajax/edit/${data.id}`, {
      qrTitle: data.qrTitle,
      advertisingIabCategories: data.category || [],
      ...coords,
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};
